import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser } from '../services/AuthService';

const PrivateRoute = () => {
  const user = getCurrentUser();
  return user && user.name ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;